import React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { ReactComponent as MarketoLogo } from 'Assets/svg/export_icons/marketo.svg';
import { ReactComponent as CloseIcon } from 'Assets/svg/close-material.svg';
import { CRMExportHeader } from './crmExportComponents';
import Input from '../newInputField';
import CancelSaveButton from '../CancelSaveButton';

class MarketoExportState {
  @observable showPopup = false;

  @observable errorResponse = null;

  defaultPopupValue = {
    title: '',
    actionBtnText: 'Export',
    callback() {
      console.log('callback');
    },
  };

  defaultAuthValue = { end_point: '', client_id: '', client_secret: '' };

  @observable popupValues = this.defaultPopupValue;

  @observable authValues = this.defaultAuthValue;

  @action
  setShowPopup = val => {
    this.showPopup = val;
    if (val === false) this.popupValues = this.defaultPopupValue;
  };

  @action
  setErrorResponse = val => {
    this.errorResponse = val;
  };

  @action
  setPopupValues = val => {
    this.popupValues = { ...this.popupValues, ...val };
  };

  @action
  setAuthValues = (val = this.defaultAuthValue) => {
    console.log('def ', val);
    this.authValues = { ...this.authValues, ...val };
  };
}
const marketoExportState = new MarketoExportState();

const MarketoAuthenticationPopup = observer(props => {
  const defautState = JSON.parse(JSON.stringify(marketoExportState.authValues));
  const [stateValues, setStateValues] = React.useState(defautState);
  const [errors, setErrors] = React.useState(defautState);

  const confirmClick = () => {
    if (
      stateValues.end_point !== undefined &&
      stateValues.end_point !== '' &&
      stateValues.client_id !== undefined &&
      stateValues.client_id !== '' &&
      stateValues.client_secret !== undefined &&
      stateValues.client_secret !== ''
    ) {
      marketoExportState.setAuthValues(stateValues);
      marketoExportState.popupValues.callback(stateValues);
      marketoExportState.setShowPopup(false);
    } else {
      setErrors({
        end_point: !stateValues.end_point,
        client_id: !stateValues.client_id,
        client_secret: !stateValues.client_secret,
      });
    }
  };

  const setInputValues = (name, value) => {
    setErrors({
      ...errors,
      [name]: errors[name] !== '' ? !value : errors[name],
    });
    setStateValues({ ...stateValues, [name]: value });
  };

  React.useEffect(() => {
    if (marketoExportState.showPopup)
      setStateValues(JSON.parse(JSON.stringify(marketoExportState.authValues)));
  }, [marketoExportState.showPopup]);

  return (
    marketoExportState.showPopup && (
      <>
        <div className="marketoAuthModal confirmation-popup common-popup">
          <section className="authContianer popup-wrap">
            <div
              className="popup-close"
              title="Click here to close"
              onClick={() => marketoExportState.setShowPopup(false)}
            >
              <CloseIcon />
            </div>
            <CRMExportHeader
              Logo={MarketoLogo}
              title="Marketo Export"
              message="Use your Marketo API Credentials for connecting with Adapt"
            />
            <div className="popup-body">
              <Input
                inputProps={{
                  type: 'text',
                  name: 'marketoRestApiKey',
                  id: 'end_point',
                  placeholder: 'Example: https://some-endpoint-id.mktorest.com',
                  onChange: value => setInputValues('end_point', value),
                  value: stateValues.end_point,
                  required: true,
                }}
                error={errors.end_point ? 'Please enter the endpoint' : ''}
                label="End Point"
              />
              <Input
                inputProps={{
                  type: 'text',
                  name: 'marketoClientId',
                  id: 'client_id',
                  placeholder: 'Client Id',
                  onChange: value => setInputValues('client_id', value),
                  value: stateValues.client_id,
                  required: true,
                }}
                error={errors.client_id ? 'Please enter the client ID' : ''}
                label="Client ID"
              />
              <Input
                inputProps={{
                  type: 'text',
                  name: 'marketoClientSecret',
                  id: 'client_secret',
                  placeholder: 'Client Secret',
                  onChange: value => setInputValues('client_secret', value),
                  value: stateValues.client_secret,
                  required: true,
                }}
                error={
                  errors.client_secret ? 'Please enter the Client Secret' : ''
                }
                label="Client Secret"
              />
              {marketoExportState.errorResponse !== null &&
                marketoExportState.errorResponse.errorDescription !==
                  undefined && (
                  <div className="error-text show" id="errMarketo">
                    {marketoExportState.errorResponse.errorDescription}
                  </div>
                )}
            </div>
            <div className="footer-section">
              <CancelSaveButton
                saveButtonText="Export"
                handleSave={confirmClick}
                handleCancel={() => marketoExportState.setShowPopup(false)}
              />
            </div>
          </section>
        </div>
        <div
          className="common-popup-mask"
          onClick={() => marketoExportState.setShowPopup(false)}
        />
      </>
    )
  );
});

export default MarketoAuthenticationPopup;
export { MarketoAuthenticationPopup, marketoExportState };
